export const selectorZone = (state) => {
  const district = state.humidityZone.district;
  const region = state.humidityZone.region;
  const locality = state.humidityZone.locality;
  const humidity = state.humidityZone.humidity;
  const subject = state.humidityZone.subject;

  return [district, region, locality, humidity, subject]
}

export const isFullFilledZone = (state) => {
  const district = state.humidityZone.district?.value;
  const region = state.humidityZone.region?.value;
  const locality = state.humidityZone.locality?.value;

  return !!district && !!region && !!locality
}